<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-05-23 10:26:12
 * @LastEditors: xulongyong
 * @LastEditTime: 2024-09-06 17:14:28
 * @FilePath: \vue-privilege-routing\src\pages\login\index.vue
-->
<template>
  <div id="login_wrap">
    <div class="login_form">
      <el-tabs type="border-card" :stretch="true">
        <el-tab-pane label="账户登录"
          ><div id="login">
            <div class="login--account">
              <span>账号：</span>
              <input
                type="text"
                placeholder="随便输"
                name="account"
                @change="checkLogin($event)"
                v-model.trim="account"
              />
            </div>
            <div class="login--account">
              <span>机构：</span>
              <el-select v-model="rolesLists" placeholder="请选择">
                <el-option
                  v-for="item in units"
                  :key="item.organizeId"
                  :label="item.organizeShorthand"
                  :value="item.rolesLists"
                >
                </el-option>
              </el-select>
            </div>

            <div class="login--password">
              <span>密码：</span>
              <input
                type="password"
                placeholder="随便输"
                name="password"
                v-model.trim="password"
                @keyup.enter="login"
              />
              <div class="forget-pw-safe">
                <a
                  href="//passport.jd.com/uc/links?tag=safe"
                  target="_blank"
                  clstag="pageclick|keycount|passport_main|click_forget_pwd"
                  >忘记密码</a
                >
              </div>
            </div>

            <div style="width: 100%; display: flex; justify-content: center;">
              <button class="button-login" @click="doLogin">登录</button>
            </div>
          </div>
          <div class="register-safe">
            <a
              href="http://localhost:8080/register"
              target="_blank"
              clstag="pageclick|keycount|passport_main|click_forget_pwd"
              >没有账号,请点击注册</a
            >
          </div>
        </el-tab-pane>
        <el-tab-pane label="扫码登录">扫码登录</el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { doLogin, checkLogin, registerSubmit } from '../../api'

export default {
  data() {
    return {
      loading: false,
      units: [],
      rolesLists: [],
      account: '',
      password: '',
      roleId: ''
    }
  },
  methods: {
    async doLogin() {
      const data = {
        account: this.account,
        organizeId: this.rolesLists[0].organizeId,
        roleId: this.rolesLists[0].roleId
      }
      // 网络请求
      let result = await doLogin(data)
      let token = result.token
      let account_token = result.account_token

      // 本地  vuex
      this.$store.commit('LOGIN_IN', token)
      this.$store.commit('ACCOUNT_TOKEN', result.account_token)
      this.$router.replace('/')
    },

    async checkLogin(e) {
      const data = {
        account: e.srcElement._value
      }
      // 网络请求
      let result = await checkLogin(data)
      this.units = result

      console.log('result.data', result)
    },

    doRegister() {
      console.log('点击这里,需要跳转到注册页面!')
    }

    // doLogin() {
    //   const data = {
    //     username: this.account
    //   }
    //   axios
    //     .post('api/commonLogin/logoAccount.do', data)
    //     .then(res => {
    //       console.log("执行了",res)
    //       const token = res.data.token
    //       this.$store.commit('LOGIN_IN',token);
    //       this.$router.replace("/")
    //     })
    // }
  },
  mounted() {}
}
</script>
<style scoped lang="scss">
#login_wrap {
  position: relative;
  background: url(../../assets/jianghu.jpg);
  padding-left: 50%;
  padding-top: 12%;
    .login_form {
    width: 40%;
    line-height: 68px;

    #login {
      margin-top: 36px;
    }

    span {
      color: #666;
      // display: inline-block;
      width: 24%;
      font-size: 20px;
      margin-left: 27px;
    }
    input {
      background: none;
      font-size: 16px;
      border: 1px solid rgb(223, 222, 222);
      border-radius: 4px;
      height: 20%;
      width: 234px;
      padding: 10px;
      box-sizing: border-box;
      color: #666;
      &.error {
        border: 1px solid #f00;
      }
      &::-webkit-input-placeholder {
        color: #aaa;
      }
    }
    .el-select {
      width: 234px;
    }

    .button-login {
      display: block;
      width: 90%;
      height: 42px;
      font-size: 18px;
      background: #0f6171;
      border: none;
      color: #fff;
      border-radius: 6px;
      cursor: pointer;
    }
    .forget-pw-safe {
      line-height: 36px;
      margin-left: 80%;
      font-size: 12px;
      padding-bottom: 6px;
      a:hover {
        border-bottom: 1px solid #f00;
        color: #f00;
      }
    }
    .register-safe {
      line-height: 32px;
      padding-left: 51%;
      font-size: 16px;
      padding-top: 16px;
      a:hover {
        border-bottom: 1px solid #f00;
        color: #f00;
      }
    }
  }
}
</style>
